import React from 'react';
import {View, TouchableOpacity, StyleSheet} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';

interface MiniTournamentBannerProps {
  name: string;
  startDateIso: string;
  onOpen: () => void;
}

function formatTimeUntil(startDateIso: string): string {
  const target = new Date(startDateIso).getTime();
  const now = Date.now();
  const diffSec = Math.round((target - now) / 1000);
  if (diffSec <= 0) return 'Live now';
  if (diffSec < 60) return `Starts in ${diffSec}s`;
  const min = Math.floor(diffSec / 60);
  const sec = diffSec % 60;
  return `Starts in ${min}m ${sec}s`;
}

export default function MiniTournamentBanner({
  name,
  startDateIso,
  onOpen,
}: MiniTournamentBannerProps) {
  const [, force] = React.useReducer((x: number) => x + 1, 0);
  React.useEffect(() => {
    const id = setInterval(() => force(), 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <View style={styles.banner}>
      <MaterialCommunityIcons
        name="trophy-outline"
        size={20}
        color={CCColors.White}
      />
      <View style={styles.textCol}>
        <CCText
          fontSize={FontSizes[14]}
          fontWeight={600}
          color={CCColors.White}>
          Classroom tournament: {name}
        </CCText>
        <CCText fontSize={FontSizes[12]} color={CCColors.White}>
          {formatTimeUntil(startDateIso)}
        </CCText>
      </View>
      <TouchableOpacity onPress={onOpen} style={styles.openBtn}>
        <CCText
          fontSize={FontSizes[13]}
          fontWeight={600}
          color={CCColors.Orange}>
          Open Tournament
        </CCText>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: CCColors.Orange,
    paddingHorizontal: 16,
    paddingVertical: 10,
    marginHorizontal: 12,
    marginTop: 8,
    borderRadius: 8,
  },
  textCol: {
    flex: 1,
    flexDirection: 'column',
  },
  openBtn: {
    backgroundColor: CCColors.White,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 6,
  },
});
